<template>
  <span class="fs-90 ml-2 pl-2 text-normalcase" :class="{'border-left': isLimited}">
    <template v-if="!hasResults && $store.state.pool.test_campaign_creation.available !== -1">
      Felhasználható kredited:
      <span :class="classFor($store.state.pool.test_campaign_creation)">{{ $store.state.pool.test_campaign_creation.available}} darab kampányt készíthetsz</span>
    </template>
    <template v-if="hasResults && $store.state.pool.test_rating.available !== -1">
      Felhasználható kredited:
      <span :class="classFor($store.state.pool.test_rating)">{{ $store.state.pool.test_rating.available}} darab teszt</span>
    </template>
  </span>
</template>
<style>
  .text-normalcase {
    text-transform: none;
  }
</style>
<script>
  export default {
    props: {
      hasResults: {
        type: Boolean,
        default: false,
      }
    },
    computed: {
      isLimited() {
        return this.$store.state.pool.test_campaign_creation.available !== -1 ||
          this.$store.state.pool.test_rating.available !== -1
      }
    },
    methods: {
      classFor(pool) {
        if (pool.available === 0 || pool.available / pool.maximum < 0.2) {
          return 'text-danger'
        } else {
          return 'text-info'
        }
      }
    }
  }
</script>